import dayjs from "dayjs";
import { mapState, mapActions } from "vuex";
import Paginate from "@/components/common/Paginate.vue";
import ExcelManagePopup from "@/components/modal/ExcelManagePopup.vue";

export default {
  name: "ExcelTemplateList",
  components: {
    Paginate,
    ExcelManagePopup,
  },
  data() {
    return {
      loading: false,
      sortOrder: "created_desc",
      
      // 커스텀 양식 데이터
      customTemplates: [],
      totalCount: 0,
      currentPage: 1,
      pageSize: 10,
      
      // 선택 관련
      allSelected: false,
      selectedTemplates: [],
      
      // 모달 관련
      showModal: false,
      editingTemplate: null,
    };
  },
  
  computed: {
    ...mapState("common", ["mall_id", "real_mall_id"]),
    
    // 실제 mall_id 값
    currentMallId() {
      return this.real_mall_id || this.mall_id;
    },
    
    // 페이지네이션 오프셋
    offset() {
      return (this.currentPage - 1) * this.pageSize;
    },
    
    // 선택 가능한 커스텀 템플릿 (프리셋 제외)
    selectableTemplates() {
      return this.customTemplates.filter(template => !template.is_preset);
    },
    
    totalTemplateCount() {
      return this.totalCount;
    },
  },
  
  async created() {
    // URL 쿼리 파라미터에서 page_no 확인
    const pageParam = this.$route.query.page_no;
    if (pageParam) {
      // 쿼리 파라미터가 있으면 현재 페이지로 설정
      this.currentPage = parseInt(pageParam, 10) || 1;
    }
    await this.initializeData();
  },
  
  methods: {
    ...mapActions("supply", [
      "getCustomExcelTemplates", 
      "bulkDeleteCustomExcelTemplates",
    ]),
    
    // 초기 데이터 로드
    async initializeData() {
      this.loading = true;
      try {
        await Promise.all([
          this.loadAllTemplates()
        ]);
      } catch (error) {
        console.error("엑셀 양식 데이터 로드 실패:", error);
        alert("엑셀 양식 목록을 불러오는데 실패했습니다.");
      } finally {
        this.loading = false;
      }
    },
      // 모든 템플릿 로드 (프리셋 + 커스텀)
    async loadAllTemplates() {
      try {
        console.log("📋 모든 템플릿 데이터 로드 시작");
        
        const params = {
          order: "create_desc",
          type: "all",
          offset: this.offset,
          limit: this.pageSize,
        };
        
        const response = await this.getCustomExcelTemplates(params);
        this.customTemplates = response.list || [];
        
        this.totalCount = response.total_count || 0;
        
        console.log("📋 커스텀 템플릿:", this.customTemplates.length);
        
        // 페이지네이션 설정
        this.setPagination();
        
      } catch (error) {
        console.error("템플릿 로드 실패:", error);
        this.customTemplates = [];
        this.totalCount = 0;
      }
    },
    
    // 페이지네이션 설정
    setPagination() {
      this.$nextTick(() => {
        if (this.$refs.Paginate) {
          this.$refs.Paginate.setPaging(
            this.totalCount,     // 전체 총 개수
            this.pageSize,       // 페이지당 개수
            this.totalCount,     // 실제 조회된 개수
            this.totalCount      // 조회된 총 개수
          );
        }
      });
    },
    
    // 전체 선택 토글 (커스텀 템플릿만)
    toggleAllSelection() {
      this.selectableTemplates.forEach(template => {
        template.selected = this.allSelected;
      });
      this.updateSelection();
    },
    
    // 선택 상태 업데이트 (커스텀 템플릿만)
    updateSelection() {
      this.selectedTemplates = this.selectableTemplates.filter(template => template.selected);
      this.allSelected = this.selectableTemplates.length > 0 && 
                        this.selectedTemplates.length === this.selectableTemplates.length;
    },
    
    // 날짜 포맷팅
    formatDate(dateString) {
      if (!dateString) return '-';
      return dayjs(dateString).format('YYYY-MM-DD');
    },
    
    // 일괄 삭제
    async bulkDelete() {
      if (this.selectedTemplates.length === 0) {
        alert('삭제할 양식을 선택해주세요.');
        return;
      }
      
      if (!confirm(`선택된 엑셀양식을 삭제하시겠습니까?`)) {
        return;
      }
      
      try {
        const templateIds = this.selectedTemplates.map(t => t.custom_setting_id);
        await this.bulkDeleteCustomExcelTemplates(templateIds);
        alert('삭제되었습니다.');
        
        // 선택 상태 초기화
        this.allSelected = false;
        this.selectedTemplates = [];
        
        await this.loadAllTemplates();
      } catch (error) {
        console.error('일괄 삭제 실패:', error);
        alert('양식 삭제에 실패했습니다.');
      }
    },
    
    // 모달 관련 메서드들
    // 새 양식 등록 모달 열기
    openCreateModal() {
      this.editingTemplate = null;
      this.showModal = true;
      return false;
    },
    
    // 양식 수정 모달 열기
    openEditModal(template) {
      this.editingTemplate = template;
      this.showModal = true;
    },
    
    // 모달 닫기
    closeModal() {
      this.showModal = false;
      this.editingTemplate = null;
    },
    
    // 템플릿 저장 완료 핸들러
    async handleTemplateSaved(templateData) {
      console.log("템플릿 저장됨:", templateData);
      // 목록 새로고침
      await this.loadAllTemplates();
    },
    
    // 페이지 사이즈 변경 핸들러
    async handlePageSizeChange() {
      // 페이지 사이즈 변경 시 첫 페이지로 이동
      this.currentPage = 1;
      
      // 선택 상태 초기화
      this.allSelected = false;
      this.selectedTemplates = [];
      
      // 데이터 다시 로드
      await this.loadAllTemplates();
    }
  }
};
